import { orderUploadStyles as styles } from "@insite/content-library/Components/OrderUpload";
import getColor from "@insite/mobius/utilities/getColor";
import { button, buttonCommon } from "@solveindustrial/Utilities/styleguide/button";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.uploadLinkTooltipText = {
    ...styles.uploadLinkTooltipText,
    css: css`
        ${styles.uploadLinkTooltipText?.css}
        &&& {
            font-size: 16px;
            line-height: 1.5;
        }
    `,
};

styles.downloadTemplateButton = {
    ...styles.downloadTemplateButton,
    variant: "primary",
    mergeCss: true,
};

styles.fileUploader = {
    ...styles.fileUploader,

    buttonProps: {
        ...buttonCommon,
        variant: "primary",
        css: css`
            height: 30px;
            line-height: 30px;
            min-height: 30px;
            margin: 40px 0 0 5px;

            ${mediaQueriesBP.minMD} {
                height: 50px;
                line-height: 50px;
                margin-top: 42px;
            }
        `,

        mergeCss: true,
    },
};

styles.uploadFileButton = {
    ...styles.uploadFileButton,
    variant: "primary",
    css: css`
        ${styles.uploadFileButton?.css}
        ${button.primary.css};

        &:disabled {
            background-color: ${getColor(colorStrings.commonGlobalGray03)};
            color: ${getColor(colorStrings.commonGlobalWhite)};
            border-color: ${getColor(colorStrings.commonGlobalGray03)};

            span {
                color: ${getColor(colorStrings.commonGlobalWhite)};
            }
        }
    `,
};

styles.uploadFileButtonLabel = {
    ...styles.uploadFileButtonLabel,
    ...buttonCommon.typographyProps,
    mergeCss: true,
};

styles.includeFirstRowCheckbox = {
    ...styles.includeFirstRowCheckbox,
    css: css`
        display: flex;
        align-items: center;
        width: 100%;
        margin-block: 15px;
    `,
    mergeCss: true,
};
